//  This is a generated file, do not edit it directly
import SvgIcon from '@mui/material/SvgIcon';
import type { TpBaseSvgIconProps } from '../types/muiSvgIcon';
import { SvgInfo } from '../icons/Info';

export function InfoIcon(props: TpBaseSvgIconProps): React.ReactElement {
  return (
    <SvgIcon {...props} component={SvgInfo} data-qa="InfoIcon">
      <svg />
    </SvgIcon>
  );
}
